import A11yDialog from 'a11y-dialog';

const SupplierProfile = {
  init: function (selector) {
    this.element = document.querySelector(selector);
    if (this.element) {
      const mainEl = document.getElementById('main');
      const declineDialogEl = document.getElementById('decline-dialog');
      const enquiryDialogEl = document.getElementById('enquiry-dialog');
      const postponeDialogEl = document.getElementById('postpone-dialog');

      if (declineDialogEl) {
        const declineDialog = new A11yDialog(declineDialogEl, mainEl); // eslint-disable-line no-unused-vars
      }

      if (enquiryDialogEl) {
        const enquiryDialog = new A11yDialog(enquiryDialogEl, mainEl); // eslint-disable-line no-unused-vars
      }

      if (postponeDialogEl) {
        const postponeDialog = new A11yDialog(postponeDialogEl, mainEl); // eslint-disable-line no-unused-vars
      }
    }
  }
};

export default SupplierProfile;
